import { PropsWithChildren, useState } from "react"

type FileDropProps = {
  onFileDrop: (files: FileList) => void
}

export function useFileDrop(props: FileDropProps) {
  const [draggingOver, setDraggingOver] = useState<FileList | null>(null)

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    setDraggingOver(e.dataTransfer.files)
  }

  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    setDraggingOver(null)
  }

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    if (e.dataTransfer.files.length > 0) {
      props.onFileDrop?.(e.dataTransfer.files)
      e.dataTransfer.clearData()
    }
    setDraggingOver(null)
  }

  return {
    bind() {
      return {
        onDragOver: handleDragOver,
        onDrop: handleDrop,
        onDragLeave: handleDragLeave,
      }
    },
    draggingOver,
  }
}

type DragIndicatorProps = PropsWithChildren<{}>

export function FileDragIndicator(props: DragIndicatorProps) {
  return (
    <div className="pointer-events-none absolute inset-0 shadow-[0_0_0_3px_inset_black] flex items-center justify-center type-body-xl z-10 bg-white/50">
      {props.children}
    </div>
  )
}
